function loader (src) {
  return new Promise((resolve) => {
    var s,
      r,
      t
    r = false
    s = document.createElement('script')
    s.type = 'text/javascript'
    s.src = src
    s.onload = s.onreadystatechange = function () {
      // console.log( this.readyState ); //uncomment this line to see which ready states are called.
      if (!r && (!this.readyState || this.readyState === 'complete')) {
        r = true
        resolve()
      }
    }
    t = document.getElementsByTagName('script')[0]
    t.parentNode.insertBefore(s, t)
  })
}

function rejectObj(src) {
  return {
    errno: 10003,
    errmsg: `加载${src}超时`
  }
}

function timeout (src) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      reject(rejectObj(src))
    }, 5000)
  })
}

function loadScript (src) {
  return Promise.race([loader(src), timeout(src)])
}

export {
  loadScript
}
